import React from 'react'
import { isRouteErrorResponse, useRouteError } from 'react-router'
import { useOtherGroupReload } from './useOtherGroupReload'
import type { RouteGroup } from './index'

const NOT_FOUND_STATUS = 404

type RouteErrorBoundaryProps = {
  loadedGroup: RouteGroup
}

// NOTE: data router は未マッチのパスに対して 404 の ErrorResponse を投げるため、
// ErrorBoundary を置かないと react-router 既定のエラー画面
//（"Unexpected Application Error!" とスタックトレース）が描画されてしまう。
//
// 404 ページの描画は各グループの catch-all ルートが担当する（member.tsx / client.tsx）。
// ErrorBoundary は catch-all で拾えないケースの受け皿として、以下だけを担う。
// - 別グループのパスへ遷移した場合のリロード
// - 上記以外は既定のエラー画面を抑止するため何も描画しない
const RouteErrorBoundary: React.FC<RouteErrorBoundaryProps> = ({ loadedGroup }) => {
  const error = useRouteError()
  const isNotFound = isRouteErrorResponse(error) && error.status === NOT_FOUND_STATUS

  useOtherGroupReload(loadedGroup, isNotFound)

  return null
}

export default RouteErrorBoundary
